import { FormControl, FormGroup } from '@angular/forms';
import { AddressFormBuilder } from '../../../../../shared/components/address/form-address/form-group/address.form.builder';
import { EditBeneficiaryAddressFormModel } from './edit-beneficiary-address-form.model';
import { Beneficjent } from '../../../../../shared/models/beneficjent';

export class EditBeneficiaryAddressFormBuilder {
  public static createFormGroup(
    beneficjent?: Beneficjent,
  ): FormGroup<EditBeneficiaryAddressFormModel> {
    const fg = new FormGroup<EditBeneficiaryAddressFormModel>({
      czyAdresKorespondencyjny: new FormControl(
        beneficjent?.czyAdresKorespondencyjny || false,
      ),
      adres: AddressFormBuilder.createFormGroup(
        beneficjent?.adres || undefined,
      ),
      adresKorespondencyjny: AddressFormBuilder.createFormGroup(
        beneficjent?.adresKorespondencyjny || undefined,
      ),
    });

    if (!fg.controls.czyAdresKorespondencyjny.value) {
      fg.controls.adresKorespondencyjny.disable();
    }

    return fg;
  }

  public static toModel(
    fg: FormGroup<EditBeneficiaryAddressFormModel>,
    beneficjent: Beneficjent,
  ): Beneficjent {
    const czyAdresKorespondencyjny =
      fg.controls.czyAdresKorespondencyjny.value || false;

    beneficjent.adres = AddressFormBuilder.mapAdres(fg.controls.adres);

    beneficjent.czyAdresKorespondencyjny = czyAdresKorespondencyjny;
    beneficjent.adresKorespondencyjny = AddressFormBuilder.mapAdres(
      fg.controls.adresKorespondencyjny,
      true,
      czyAdresKorespondencyjny,
    );

    return beneficjent;
  }
}
